<template>
    <div id="root">
        <b-row>
            <b-col>
                <h2>Orders In Progress</h2>
                <OrdersTable :items="drafts" :isLoading="draftLoading" v-on:delete-order="deleteSuccess" modalId="draft" v-on:order-emit="$emit('order-emit')"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <h2>Submitted Orders</h2>
                These orders have been submitted but not yet paid for.
              <OrdersTable :items="pay" :isLoading="paidLoading" v-on:delete-order="deleteSuccess" modalId="pay" v-on:order-emit="$emit('order-emit')"/>
            </b-col>
        </b-row>
<!--        <b-row class="mt-2">-->
<!--            <b-col>-->
<!--                <h2>Completed Orders</h2>-->
<!--                PLACEHOLDER TEXT!!-->
<!--                Orders which have been delivered/completed go here.  TODO: what fields should go here?-->
<!--            </b-col>-->
<!--        </b-row>-->
        <b-row class="mt-2">
            <b-col>
                <router-link :to="{name: 'summary'}">
                    <b-button id="btnCart" variant="primary">View Cart</b-button>
                </router-link>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import axios from "axios"
import axiosRetry from 'axios-retry'
import moment from 'moment';
import LocalStorageService from "@/common/LocalStorageService";
import OrdersTable from "@/components/templates/display/OrdersTable";
import {toastService} from "@/mixins/toastService";

const localStorageService = LocalStorageService.getService();

axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  })

export default {
    props: {
    },
    data: () => ({
        drafts: [],
        pay: [],
        draftLoading: true,
        paidLoading: true,
    }),

    components: {
        OrdersTable
    },

    methods: {
        formatDate(unformattedDate){
            let formattedDate = moment(unformattedDate);
            if(!unformattedDate || !formattedDate.isValid()) return '';
            return formattedDate.format("MM/DD/YYYY")
        },
        fetchDrafts() {
            if (localStorageService.getOrderNumber()) {
                setTimeout(() => {
                    axios.get(`${process.env.VUE_APP_API_BASE_URL}/order/drafts`)
                        .then(response=>{
                            this.drafts = response.data
                            this.draftLoading = false
                        })
                }, 500)
            } else {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/order/drafts`)
                    .then(response=>{
                        this.drafts = response.data
                        this.draftLoading = false
                    })
            }
        },
        fetchPayOrders() {
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/order/pay`)
              .then(response=>{
                this.pay = response.data
                this.paidLoading = false
              })
        },
        fetchOrders() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/order/profile`)
                .then(response=>{
                    this.orders = response.data
                })
        },
        deleteSuccess(type) {
          toastService.showRootToast("Success", "Order Cancelled", "success", this.$root)
          if (type === 'DRAFT') {
            this.fetchDrafts()
          } else {
            this.fetchPayOrders()
          }
        },
    },
    mounted() {
        this.fetchDrafts()
        this.fetchPayOrders()
    },
    computed: {
    }
}
</script>